import React from 'react'

const ProfileSectionCms = ({ section }) => {
  if (section.displayAttribution) {
    return (
      <p className="text-right">
        <i>
          source:
          <a href={section.sourceUrl}>{section.sourceName}</a>
        </i>
      </p>
    )
  }

  return null
}

export default ProfileSectionCms
